import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 27 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		opacity: .3,
		children: /* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M22.2599 7.84922C21.3884 7.84795 20.553 7.50109 19.937 6.88472C19.3209 6.26835 18.9744 5.43278 18.9736 4.56131V0H4.28877C3.15131 0 2.06047 0.451846 1.25617 1.25615C0.451865 2.06045 0 3.15133 0 4.28879V30.1426C0 31.2801 0.451865 32.3709 1.25617 33.1752C2.06047 33.9795 3.15131 34.4314 4.28877 34.4314H21.9157C22.479 34.4316 23.0369 34.3208 23.5574 34.1054C24.0779 33.8899 24.5509 33.5741 24.9493 33.1758C25.3477 32.7775 25.6638 32.3046 25.8794 31.7842C26.095 31.2638 26.206 30.7059 26.206 30.1426V7.84922H22.2599Z",
			fill: "#FF9908"
		})
	}), /* @__PURE__ */ _jsx("path", {
		d: "M26.2061 7.84922H22.2599C21.3885 7.84795 20.5531 7.50109 19.937 6.88472C19.3209 6.26835 18.9745 5.43278 18.9736 4.56131V0L26.2061 7.84922Z",
		fill: "#FF9908"
	})]
});
export default SvgDefault;
